import React from 'react';
import styles from './AdminRadio.module.css';
import { Form } from 'react-bootstrap';

export default function AdminRadio({ label, options, id, checkedValue, isReadOnly, onChange }) {
  return (
    <>
      <div className={styles.label}>{label}</div>
      {options.map(option =>
        <Form.Check inline
          className={styles.radio}
          key={`${option.label}-${id}-radio`}
          type="radio"
          id={`${id}-${option.label}-radio`}
          name={`radio_${id}`}
          label={option.label}
          checked={checkedValue === option.value}
          disabled={!!isReadOnly}
          onChange={e => onChange(option.value)} />
      )}
    </>
  );
}